import React from "react";
import { AlertCircle, ArrowUpCircle, MinusCircle } from "lucide-react";
import UseGetDashBoardData from "../../../../Components/Hooks/useDashboardData";

function OpenTicket() {
  const { data, loading } = UseGetDashBoardData(`/dashboard/open-tickets`);

  return (
    <div className="col-span-2 bg-white h-[50vh] 2xl:h-[54vh] w-full p-4 rounded-2xl shadow-lg  flex flex-col ">
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-sm font-bold text-gray-700">Open Tickets</h2>
        <span className="text-xs  text-gray-800 font-bold px-3 py-1 ">
          {data?.total}
        </span>
      </div>

      <div className="overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent h-full">
        <div className="space-y-4">
        <div className="flex items-center justify-between border p-3 rounded-xl shadow-sm hover:shadow-md transition duration-200">
            <div className="flex items-center gap-2">
              <ArrowUpCircle className="text-red-500 h-4 w-4" />
              <p className="text-sm font-medium text-gray-600">High Priority</p>
            </div>
            <span className="text-xs font-bold text-gray-700 bg-red-100 px-3 py-1 rounded-full">
              {data?.high_priority}
            </span>
          </div>
           

             <div className="flex items-center justify-between border p-3 rounded-xl shadow-sm hover:shadow-md transition duration-200">
            <div className="flex items-center gap-2">
              <AlertCircle className="text-yellow-500 h-4 w-4" />
              <p className="text-sm font-medium text-gray-600">Medium Priority</p>
            </div>
            <span className="text-xs font-bold text-gray-700 bg-yellow-100 px-3 py-1 rounded-full">
              {data?.medium_priority}
            </span>
          </div>
          <div className="flex items-center justify-between border p-3 rounded-xl shadow-sm hover:shadow-md transition duration-200">
            <div className="flex items-center gap-2">
              <MinusCircle className="text-blue-500 h-4 w-4" />
              <p className="text-sm font-medium text-gray-600">Low Priority</p>
            </div>
            <span className="text-xs font-bold text-gray-700 bg-blue-100 px-3 py-1 rounded-full">
              {data?.low_priority}
            </span>
          </div>
          
        </div>
      </div>
    </div>
  );
}

export default OpenTicket;
